import { Backdrop, CircularProgress, Container, Dialog, DialogActions, DialogContentText, Grid } from '@material-ui/core'
import { Add as AddIcon, ArrowBack, Save as SaveIcon } from '@material-ui/icons'
import { isAfter, isEqual, set as setDate } from 'date-fns'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import Success from '../../../components/Form/Success'
import AlertDialog from '../../../components/ui/AlertDialog'
import ButtonUI from '../../../components/ui/ButtonUI'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import { MvmSubmit } from '../../../interfaces/Mvm'
import MvmStatus from '../../../interfaces/MvmStatus'
import MvmApi from '../../../services/MvmApi'
import ShedApi from '../../../services/ShedApi'
import ShippingRequestApi from '../../../services/ShippingRequestApi'
import VehicleApi from '../../../services/VehicleApi'
import VehicleTypeApi from '../../../services/VehicleTypeApi'
import { MOPAR_PLANT_ID } from '../../../utils/constants'
import CpfCnpj from '../../../utils/CpfCnpj'
import permissions from '../../../utils/Permissions'
import MvmCompositionPartInfo from '../components/MvmCompositionPartInfo'
import MvmGeneralInfo from '../components/MvmGeneralInfo'
import MvmInvoiceItemsList from '../components/MvmInvoiceItemsList'
import MvmInvoiceList from '../components/MvmInvoiceList'
import MvmLogList from '../components/MvmLogList'
import MvmRackLoadList from '../components/MvmRackLoadList'
import MvmShedList from '../components/MvmShedList'
import MvmSubmitSummary from '../components/MvmSubmitSummary'
import { DialogTitle, useStyles } from '../Style'

interface IFormInput {
  suppliers: any;
  shippingSupplier: any;
  shippingCompanySupplier: any;
  driverName: any;
  driverRGNumber: any;
  driverCPFNumber: any;
  driverCNHType: any;
  driverCNHNumber: any;
  driverCNHExpirationDate: Date | null;
  vehiclePlateNumber: any;
  cartPlateNumber: any;
  vehicleType: any;
  vehicleBrandDescription: any;
  helperQuantity: any;
  cTeNumber: any;
  poolPoint: any;
  composition: any;
  observation: any;
  salesInvoices: any;
  otherInvoices: any;
  campolargoInvoices: any;
  invoiceItemsGeneral: any;
  invoiceItemsSales: any;
  invoiceItemsRack: any;
  containerNumber: any;
  pcabNumber: any;
  origin: any;

  // Info notas carreta entrada, (se necessário)
  invoiceItemsGeneralCartEntry: any;
  invoiceItemsSalesCartEntry: any;
  invoiceItemsRackCartEntry: any;
  rackLoadsCartEntry: any;

  // Info notas carreta saída (se necessário)
  invoiceItemsGeneralCartExit: any;
  invoiceItemsSalesCartExit: any;
  invoiceItemsRackCartExit: any;
  rackLoadsCartExit: any;

  mvmLogs: any;
  status: any;
  mvmSheds: any;
  rackLoads: any;
  newVehicle?: any;
  vehicleReleaseDateWithInvoice?: any;
}

interface UrlParameters {
  mvmId: number;
  shippingRequestIds: string;
  view: boolean;

}

const opcoes = [
  { url: '/SubmitMvm', descricao: 'Emitir MVM', state: {} },
  { url: 'printMvm', descricao: 'Imprimir MVM', state: {} },
  { url: '/mvm', descricao: 'Pesquisar', state: {} }
]

const opcoesCart = [
  { url: 'printMvm', descricao: 'Imprimir MVM (Carreta)', state: {} },
]

const Emitir: React.FC = () => {
  const classes = useStyles()
  const { user, hasPermission, isCampoLargo, isMopar, isJeep, isPortoReal } = useAuth()
  const { t: tMvm } = useTranslation("Mvm")
  const { t: tGeneral } = useTranslation("General")
  const { t: tValidation } = useTranslation("Validation")
  const { t: tMvmShed } = useTranslation("MvmShed")
  const { t: tShippingRequest } = useTranslation("ShippingRequest")
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory()
  const [circularLoading, setCircularLoading] = useState(false)
  const [loadingLog, setLoadingLog] = useState(false);
  const [openedPainel, setOpenedPainel] = React.useState(false)
  const [openedPainelAuthorizeFCA, setOpenedPainelAuthorizeFCA] = React.useState(false)
  const [title, setTitle] = useState<string>("")
  const [mvm, setMvm] = useState<any>(null)
  const [mvmStatus, setMvmStatus] = useState<string>(MvmStatus.FLAG_STATUS_DRAFT)
  const [driverCPF, setDriverCPF] = useState<string>("")
  const [mvmType, setMvmType] = useState<string>(' ')
  const [entranceDate, setEntranceDate] = useState<string>("")
  const [pngValidated, setPngValidated] = useState<boolean>(false)
  const [supplierTypes, setSupplierTypes] = useState<any>({ jit: false, misto: false, ekamban: false, leapmotor: false })
  const [success, setSuccess] = useState(false)
  const [mvmNumber, setMvmNumber] = useState<any>(null)
  const [mvmId, setMvmId] = useState<any>(null)
  const [cartMvmId, setCartMvmId] = useState<any>(null)
  const [cartMvmNumber, setCartMvmNumber] = useState<any>(null)
  const [shippingRequests, setShippingRequests] = useState<any>([])
  const [mvmCompositionEntrance, setMvmCompositionEntrance] = useState<any>(null)
  const [mvmCompositionExit, setMvmCompositionExit] = useState<any>(null)
  const { control, reset, getValues, setError, clearErrors, setValue } = useForm<IFormInput>({
    defaultValues: {
      suppliers: [],
      shippingSupplier: {},
      shippingCompanySupplier: {},
      driverName: {},
      driverRGNumber: '',
      driverCPFNumber: '',
      driverCNHType: { code: 'E', label: 'E' },
      driverCNHNumber: '',
      driverCNHExpirationDate: null,
      vehiclePlateNumber: '',
      cartPlateNumber: '',
      vehicleType: {},
      vehicleBrandDescription: '',
      helperQuantity: '0',
      cTeNumber: '',
      poolPoint: {},
      observation: '',
      salesInvoices: [],
      otherInvoices: [],
      campolargoInvoices: [],
      invoiceItemsGeneral: [],
      invoiceItemsSales: [],
      invoiceItemsRack: [],
      mvmLogs: [],
      status: {},
      mvmSheds: [],
      rackLoads: [],
      newVehicle: null,
      vehicleReleaseDateWithInvoice: '',
      composition: false,
      containerNumber: '',
      pcabNumber: '',
      origin: '',
    }
  })

  const isInsert = !mvm
  const isView = window.location.pathname.toLowerCase().includes('/view') || window.location.pathname.toLowerCase().includes('/viewpa')
  const isViewPA = window.location.pathname.toLowerCase().includes('/viewpa')
  const isEditDraft = mvm && mvm.id > 0 && mvm.status === MvmStatus.FLAG_STATUS_DRAFT && !isView
  const isEditFull = mvm && mvm.id > 0 && mvm.status !== MvmStatus.FLAG_STATUS_DRAFT && !isView
  const isViewDraft = mvm && isView && mvm.status === MvmStatus.FLAG_STATUS_DRAFT
  const isCabinComposition = mvm && mvm.composition && mvm.mvmType !== 'C' && mvm.status !== MvmStatus.FLAG_STATUS_DRAFT

  useEffect(() => {
    if (isView || isViewDraft) {
      // view
      if (!hasPermission(permissions.MVM.Search) &&
        !hasPermission(permissions.MVM.SuperUser))
        history.replace('/NoPermission');

      if (mvm && mvm.companyId !== user.company.companyID)
        history.replace('/mvm');
    }
    else if (mvm) {
      // editar
      if (!hasPermission(permissions.MVM.Edit) && !hasPermission(permissions.MVM.SuperUser))
        history.replace('/NoPermission');

      if (mvm && mvm.companyId !== user.company.companyID)
        history.replace('/mvm');

      if (mvm.status === MvmStatus.FLAG_STATUS_FINISHED && !window.location.pathname.toLowerCase().includes('/view'))
        history.replace('/NoPermission');
    } else if (!hasPermission(permissions.MVM.Add) && !hasPermission(permissions.MVM.SuperUser)) {
      // add
      history.replace('/NoPermission');
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, user, mvm])

  useEffect(() => {

    async function load() {
      if (isView || isViewDraft)
        setTitle(`Visualizar Mvm - ${mvm.mvmNumber ? mvm.mvmNumber : tGeneral("draft")}`)
      else {
        setTitle(` ${tMvm("updateMvm")}  -  ${mvm.mvmNumber ? mvm.mvmNumber : tGeneral("draft")}`)
      }

      if (mvm.status !== '')
        setMvmStatus(mvm.status)

      // O id do objeto entra em conflito com o id gerado pelo fieldarray dos componentes de nota fiscal. 
      // Criei esse parâmetro para manter o id da nota fiscal salvo, ele é recuperado no save posteriormente
      for (let i = 0; i < mvm.invoices.length; i++) {
        mvm.invoices[i].mvmInvoiceId = mvm.invoices[i].id
      }

      if (isEditDraft || isViewDraft) {
        setValue('salesInvoices', mvm.invoices.filter((x: { invoiceType: string; }) => x.invoiceType !== 'C'));
        setValue('campolargoInvoices', mvm.invoices.filter((x: { invoiceType: string; }) => x.invoiceType === 'C'));
      }
      else {

        //Gravar mvmShedId dos sheds, pois o React Hook Form sobrescreve a propriedade id com um guid. Ao salvar, deve-se restaurar id = mvmShedId
        for (var i = 0; i < mvm.sheds.length; i++) {
          mvm.sheds[i].mvmShedId = mvm.sheds[i].id;
        }

        //Cada Shed tem uma colecao de RackLoads - esta tela deve exibir todos os racks de todos os sheds
        let rackLoads: any = [];
        mvm.sheds.forEach((x: any) => {
          //Incluir os rackLoads de cada shed na lista:
          x.rackLoads.forEach((y: any) => {
            y.rackLoadId = y.id; //Setar este ID para obter depois, pois a propriedade "id" é sobrescrita pelo react hook form FieldArray
            rackLoads.push(y);
          })
        })

        await loadShedsRegistrations(mvm.sheds);

        setValue("invoiceItemsSales", mvm.invoices.filter((x: { invoiceType: string; }) => x.invoiceType === 'V'));
        setValue("invoiceItemsRack", mvm.invoices.filter((x: { invoiceType: string; }) => x.invoiceType === 'E'));
        setValue("invoiceItemsGeneral", mvm.invoices.filter((x: { invoiceType: string; }) => (x.invoiceType !== 'V' && x.invoiceType !== 'E')));

        setValue("rackLoads", rackLoads)
      }

      setValue('mvmLogs', mvm.logs)

      setMvmId(mvm.id);

      if (isViewPA) {
        saveAccountingPendingUserResolution(mvm.id);
      }


      setLoadingLog(true);
      const logs = await MvmApi.getMvmLogs(mvm.id);
      setValue('mvmLogs', logs);
      setLoadingLog(false);
    }

    if (mvm)
      load();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mvm])

  useEffect(() => {

    var suppliersTemp: {
      code: any;
      label: string;
      supplierCorporateName: any
    }[] = []

    var invoicesTemp: {
      invoiceKey: any;
      invoiceNumber: any;
      invoiceDate: any;
      invoiceSupplierId: any;
      invoiceSupplierCorporateName: any;
      invoiceType: string;
      companyId: any;
      items: any
    }[] = []

    shippingRequests.forEach((element: any) => {
      if (!suppliersTemp.some(e => e.code === element.supplierId))
        suppliersTemp.push({
          code: element.supplierId,
          label: element.supplierId + " - " + element.supplierCorporateName,
          supplierCorporateName: element.supplierCorporateName
        })
    })

    shippingRequests.forEach((element: any) => {
      if (!invoicesTemp.some(e => e.invoiceKey === element.invoiceKey))
        invoicesTemp.push({
          invoiceKey: element.invoiceKey,
          invoiceNumber: element.invoiceNumber,
          invoiceDate: element.invoiceDate,
          invoiceSupplierId: element.supplierId,
          invoiceSupplierCorporateName: element.supplierCorporateName,
          invoiceType: 'V',
          companyId: element.companyId,
          items: element.partNumbers.map((partNumber: any) => ({
            partnumberId: partNumber.partnumberId,
            partnumberCode: partNumber.partNumberCode,
            itemCode: partNumber.partNumberCode,
            itemDescription: partNumber.partNumberDescription,
            itemQuantity: partNumber.shippingQuantity
          }))
        })
    })

    setValue('suppliers', suppliersTemp)
    setValue('salesInvoices', invoicesTemp.filter((x: { invoiceType: string }) => x.invoiceType !== 'C'));
    setValue('campolargoInvoices', invoicesTemp.filter((x: { invoiceType: string }) => x.invoiceType === 'C'));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingRequests])


  const getUrlParameters = () => {
    var mvmId = Number(window.location.pathname.toLowerCase().replace('/submitmvm/', '').replace('/viewpa', '').replace('/view', ''))

    let response: UrlParameters = {
      mvmId: isNaN(mvmId) ? 0 : mvmId,
      shippingRequestIds: '',
      view: isView
    }

    var parameters = window.location.search.toLowerCase().replace('?', '').split("&")

    for (var i = 0; i < parameters.length; i++) {

      var parameter = parameters[i].split('=')

      if (parameter[0] === "shippingrequestids")
        response.shippingRequestIds = parameter[1]
    }

    return response
  }

  useEffect(() => {

    var parameters = getUrlParameters()

    if (parameters.mvmId === 0) {
      setMvm(null)
      setMvmId(null)
      setMvmStatus(MvmStatus.FLAG_STATUS_DRAFT)
      setMvmType(' ')
      setMvmCompositionEntrance(null)
      setMvmCompositionExit(null)
      setSupplierTypes(null)
      setTitle(tMvm("createSubmitMvm"))
      setDriverCPF("")
      reset()
    }

    if (parameters.shippingRequestIds.length > 0) {
      setCircularLoading(true)

      ShippingRequestApi.getMultiple(parameters.shippingRequestIds)
        .then(response => {

          if (response) {

            if (response.some((e: { status: string }) => e.status !== 'PMV')) {
              enqueueSnackbar(tShippingRequest("shippingRequestNotPreparedToSubmitMvm"), { variant: 'warning' })
              history.push('/ShippingRequest')
            }
            else
              setShippingRequests(response)
          }
        })
        .finally(() => setCircularLoading(false))
    }
    else if (parameters.mvmId > 0) {

      setCircularLoading(true)

      // var statusNotLoad = [MvmStatus.FLAG_STATUS_FINISHED]
      var statusNotLoad: any[] = [];

      MvmApi.getMvm(parameters.mvmId, "", ["Compositions", "Invoices", "Sheds", "Suppliers"])
        .then(response => {
          if (response && !statusNotLoad.includes(response.status)) {
            setMvm(response)
            setMvmId(response.id)
            setPngValidated(response.pngValidated)
            setEntranceDate(response.entranceDate)
            setMvmType(response.mvmType)
            setDriverCPF(response.driverCPFNumber)
            setCompositionsMvm(response.mvmType, response.compositions);
          } else {
            enqueueSnackbar(tGeneral("objectNotFound"), { variant: 'warning' })
            history.push('/Mvm')
          }
        })
        .finally(() => setCircularLoading(false))
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const setCompositionsMvm = (mvmType: string, compositions: any) => {
    if (compositions.length === 0)
      return

    let en: any;
    let ex: any;

    if (mvmType === "C") {
      en = compositions.filter((e: any) => e.movementType === 'EN')[0]?.cabinMvm
      ex = compositions.filter((e: any) => e.movementType === 'EX')[0]?.cabinMvm
    }
    else {
      en = compositions.filter((e: any) => e.movementType === 'EN')[0]?.cartMvm
      ex = compositions.filter((e: any) => e.movementType === 'EX')[0]?.cartMvm
    }

    setMvmCompositionEntrance(en)
    setMvmCompositionExit(ex)
  }

  const loadModelOutForm = (data: any, emitirMvm: boolean, mvmTypeAux: string) => {

    var invoices = []

    var status = isEditFull ? data.status.code : mvmStatus

    if (isInsert || isEditDraft)
      invoices = [
        ...data.salesInvoices,
        ...data.otherInvoices,
        ...data.campolargoInvoices]
    else {
      invoices = [
        ...data.invoiceItemsSales,
        ...data.invoiceItemsRack,
        ...data.invoiceItemsGeneral];

      //Restaurar id dos sheds, que foram sobrescritos pelo React hook form:
      if (data.mvmSheds)
        for (var i = 0; i < data.mvmSheds.length; i++) {
          data.mvmSheds[i].id = data.mvmSheds[i].mvmShedId;
        }
    }

    // Recuperação do id original dos objetos. Caso eles tenham sido editados no componente o id original é trocado por um guid.
    for (let i = 0; i < invoices.length; i++) {
      if (invoices[i].mvmInvoiceId)
        invoices[i].id = invoices[i].mvmInvoiceId
      else
        invoices[i].id = 0
    }

    var model: MvmSubmit = {
      scheduleDate: data.scheduleDate,
      scheduleUser: data.scheduleUser,
      windowStatus: data.windowStatus,
      deliveryWindowDate: data.deliveryWindowDate,
      windowId: data.windowId,
      unforeseenReason: data.unforeseenReason,
      presentationPlantDate: data.presentationPlantDate,
      conciergeReleaseDate: data.conciergeReleaseDate,
      conciergeReleaseUser: data.conciergeReleaseUser,
      criticalMaterialCallDate: data.criticalMaterialCallDate,
      criticalMaterialCallUser: data.criticalMaterialCallUser,
      entryAuthorizationDate: data.entryAuthorizationDate,
      entryAuthorizationUser: data.entryAuthorizationUser,
      rackDispatchReturnDescription: data.rackDispatchReturnDescription,
      submitAfterInsert: emitirMvm,
      SubmitAfterUpdate: emitirMvm,
      status: status,
      id: mvm ? mvm.id : 0,
      updatedAt: mvm ? mvm.updatedAt : undefined,
      cTeNumber: data.cTeNumber,
      poolPoint: data.poolPoint?.code,
      cartPlateNumber: data.cartPlateNumber,
      driverCNHExpirationDate: data.driverCNHExpirationDate,
      driverCNHNumber: data.driverCNHNumber,
      driverCPFNumber: data.driverCPFNumber,
      driverCNHType: data.driverCNHType?.code,
      driverRGNumber: data.driverRGNumber,
      driverName: data.driverName.code,
      helperQuantity: data.helperQuantity,
      vehiclePlateNumber: data.vehiclePlateNumber,
      vehicleBrandDescription: data.vehicleBrandDescription,
      webService: false,
      vehicleType: data.vehicleType.code,
      vehicleTypeDescription: data.vehicleType.label || mvm?.vehicleTypeDescription || '',
      observation: data.observation,
      suppliers: data.suppliers.map((x: { code: any; label: any; supplierCorporateName: any; uf: any; }) => ({
        id: 0,
        mvmId: 0,
        supplierId: Number(x.code),
        supplierCorporateName: (x.label.split(' - ')[1]),
        supplierUF: x.uf
      })),
      invoices: invoices,
      companyId: Number(user.company.companyID),
      companyName: user.company.companyName,
      companyCode: Number(user.company.companyCode),
      companyWarehouseCode: Number(user.company.warehouseID),
      companyBomCode: Number(user.company.companyBOMCode),
      plantId: Number(user.company.plantID),
      shippingSupplierId: Number(data.shippingSupplier.code),
      shippingSupplierCorporateName: data.shippingSupplier.label.includes(data.shippingSupplier.code) ? data.shippingSupplier.label.split(" - ")[1] : data.shippingSupplier.label,
      shippingSupplierCdlcCode: data.shippingSupplier.cdlcCode,
      shippingSupplierSapCode: data.shippingSupplier.sapCode,
      shippingCompanySupplierId:
        data.shippingCompanySupplier && data.shippingCompanySupplier.code ?
          Number(data.shippingCompanySupplier.code) :
          undefined,
      shippingCompanySupplierCorporateName:
        data.shippingCompanySupplier && data.shippingCompanySupplier.code ?
          (data.shippingCompanySupplier.label.includes(data.shippingCompanySupplier.code) ?
            data.shippingCompanySupplier.label.split(' - ')[1] :
            data.shippingCompanySupplier.label) :
          null,
      shippingCompanySupplierCnpj:
        data.shippingCompanySupplier && data.shippingCompanySupplier.cnpj ?
          data.shippingCompanySupplier.cnpj :
          null,
      shippingCompanySupplierSapCode: data.shippingCompanySupplier.sapCode,
      shippingCompanySupplierScacCode: data.shippingCompanySupplier.scacCode,
      mvmType: mvmTypeAux,
      sheds: data.mvmSheds,
      mvmNumber: mvm ? mvm.mvmNumber : null,
      composition: data.composition,
      containerNumber: data.containerNumber,
      pcabNumber: data.pcabNumber,
      origin: data.origin?.code
    }

    if (data.entryConcierge)
      model.conciergeCode = data.entryConcierge

    if (data.entranceDate || entranceDate) {
      model.entranceDate = data.entranceDate || entranceDate;
    }

    if (data.entranceUser)
      model.entranceUser = data.entranceUser;

    if (data.entranceUserName)
      model.entranceUserName = data.entranceUserName;

    if (pngValidated)
      model.pngValidated = pngValidated

    if (data.exitDate)
      model.exitDate = data.exitDate

    if (data.submitDate)
      model.submitDate = data.submitDate

    if (data.systemS881Return)
      model.systemS881Return = data.systemS881Return

    if (data.exitUser)
      model.exitUser = data.exitUser

    if (data.exitUserName)
      model.exitUserName = data.exitUserName

    if (data.createdBy)
      model.createdBy = data.createdBy

    return model
  }

  const formValidation = async (data: any, validateAll: boolean) => {
    if (validateAll)
      return formValidationSubmit(data)
    else
      return formValidationInclude(data)
  }

  const formValidationInclude = async (data: any) => {
    var result = false

    clearErrors()
    try {

      const schema = Yup.object().shape({
        suppliers: Yup.array().nullable().required(tValidation("requiredField"))
          .test("suppliers", tValidation("requiredField"), (value) => {
            return (value as unknown as 'any[] | null | undefined').length > 0
          }),

        shippingSupplier: Yup.object().nullable().required(tValidation("requiredField"))
          .shape({ code: Yup.string().required(tValidation("requiredField")) }),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      result = true
    }
    catch (err) {

      var errors: string[] = []

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {

          if (errors.filter(element => element.includes(error.message)).length === 0)
            errors.push(error.message)

          setError(error.path?.split('.')[0] as
            "suppliers" |
            "shippingSupplier",
            { message: error.message });
        })

        errors.forEach(element => {
          if (element === tValidation("requiredField"))
            enqueueSnackbar(tGeneral("requiredFieldsValidation"), { variant: 'warning' })
          else
            enqueueSnackbar(element, { variant: 'warning' })
        })
      }

      result = false;
    }

    return result
  }

  const validateCartPlate = (cartPlate: string | null | undefined): boolean => {
    const data = getValues()

    if (data.composition)
      return cartPlate != null && cartPlate !== "" && cartPlate.length === 7
    else
      return !cartPlate || cartPlate === "" || cartPlate.length === 7
  }

  const formValidationSubmit = async (data: any) => {
    var result = false

    clearErrors()
    try {

      const schema = Yup.object().shape({

        suppliers: Yup.array().nullable().required(tValidation("requiredField"))
          .test("suppliers", tValidation("requiredField"), (value) => {
            return (value as unknown as 'any[] | null | undefined').length > 0
          }),

        shippingSupplier: Yup.object().nullable().required(tValidation("requiredField"))
          .shape({ code: Yup.string().required(tValidation("requiredField")) }),

        shippingCompanySupplier: Yup.object().nullable().required(tValidation("requiredField"))
          .shape({ code: Yup.string().required(tValidation("requiredField")) }),

        driverCNHType: (mvmType !== '' && mvmType === 'C') ? Yup.object().nullable() : Yup.object().nullable().required(tValidation("requiredField"))
          .shape({ code: Yup.string().required(tValidation("requiredField")) }),

        driverName: (mvmType !== '' && mvmType === 'C') ? Yup.object().nullable() : Yup.object().nullable().required(tValidation("requiredField"))
          .shape({ code: Yup.string().required(tValidation("requiredField")) }),

        driverRGNumber: (mvmType !== '' && mvmType === 'C') ? Yup.string().nullable() : Yup.string().required(tValidation("requiredField")),

        driverCPFNumber: (mvmType !== '' && mvmType === 'C') ? Yup.string().nullable() : Yup.string().nullable()
          .test("driverCPFNumber", tGeneral("invalidCpf"), (value) => {
            return CpfCnpj.validateCpf(value as 'string')
          }),

        driverCNHNumber: (mvmType !== '' && mvmType === 'C') ? Yup.string().nullable() : Yup.string().required(tValidation("requiredField")),

        driverCNHExpirationDate: Yup.string().nullable().test("driverCNHExpirationDate", "A data de vencimento não pode ser inferior ao dia atual", (value) => {
          var dateRef = new Date(value as 'string')
          var dateNow = setDate(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });

          //Se o MVM for rascunho ou se o mvm não for rascunho mas o motorista foi alterado, precisa validar
          if (mvmType === '' || (mvmType !== '' && driverCPF !== getValues("driverCPFNumber")))
            return ((isEqual(dateRef, dateNow) || isAfter(dateRef, dateNow)));
          else
            return true;
        }),

        vehiclePlateNumber: Yup.string().test("vehiclePlateNumber", "Obrigatório 7 caracteres para a placa do veículo", (value) => {
          var realValue = value?.replace('_', '')
          return realValue !== undefined && realValue !== "" && realValue.length === 7
        }),

        cartPlateNumber: (mvmType !== '' && mvmType === 'C') ? Yup.string().nullable() : Yup.string().test("cartPlateNumber", "Obrigatório 7 caracteres para a placa da carreta", (value) => {
          var realValue = value?.replace('_', '')
          return validateCartPlate(realValue);
        }),

        vehicleType: Yup.object().nullable().required(tValidation("requiredField"))
          .shape({ code: Yup.string().nullable().required(tValidation("requiredField")) }),

        vehicleBrandDescription: Yup.string().required(tValidation("requiredField")),

        helperQuantity: Yup.string().nullable().required(tValidation("requiredField")),

      });
      schema.validate({})
        .catch(function (e) {
          console.log(e);
        });
      await schema.validate(data, {
        abortEarly: false,
      });

      result = true
    }
    catch (err) {

      var errors: string[] = []

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {

          if (errors.filter(element => element.includes(error.message)).length === 0)
            errors.push(error.message)

          setError(error.path?.split('.')[0] as
            "suppliers" |
            "shippingSupplier" |
            "shippingCompanySupplier" |
            "driverName" |
            "driverRGNumber" |
            "driverCPFNumber" |
            "driverCNHType" |
            "driverCNHNumber" |
            "driverCNHExpirationDate" |
            "vehiclePlateNumber" |
            "cartPlateNumber" |
            "vehicleType" |
            "vehicleBrandDescription" |
            "helperQuantity" |
            "cTeNumber" |
            "poolPoint" |
            "observation"
            , { message: error.message });
        })

        errors.forEach(element => {
          if (element === tValidation("requiredField"))
            enqueueSnackbar(tGeneral("requiredFieldsValidation"), { variant: 'warning' })
          else
            enqueueSnackbar(element, { variant: 'warning' })
        })
      }

      result = false;
    }

    return result
  }

  const validateInvoiceFiles = (data: any) => {
    // Verificar se a nota está em contingência (tpEmis)
    // O caractere que indica se a nota foi emitida em contingência é o 34
    // 1 = Emissão normal (não em contingência)
    // 2 = Contingência FS-IA, com impressão do DANFE em formulário de segurança
    // 3 = Contingência SCAN (Sistema de Contingência do Ambiente Nacional)
    // 4 = Contingência DPEC (Declaração Prévia da Emissão em Contingência)
    // 5 = Contingência FS-DA, com impressão do DANFE em formulário de segurança
    // 6 = Contingência SVC-AN (SEFAZ Virtual de Contingência do AN)
    // 7 = Contingência SVC-RS (SEFAZ Virtual de Contingência do RS)
    const isContingency = (invoiceKey: string): boolean => {
      return invoiceKey.substring(34, 35) !== '1'
    }

    var invoices = []

    if (isInsert || isEditDraft)
      invoices = [
        ...data.salesInvoices,
        ...data.otherInvoices,
        ...data.campolargoInvoices]
    else
      invoices = [
        ...data.invoiceItemsSales,
        ...data.invoiceItemsRack,
        ...data.invoiceItemsGeneral];

    for (let i = 0; i < invoices.length; i++) {
      if (isContingency(invoices[i].invoiceKey) && !invoices[i].hasFile)
        return false
    }

    return true
  }

  const onSubmitMvm = async () => {

    let data = getValues()

    var validForm = await formValidation(data, true)
    if (validForm === false) {
      return;
    }

    if (!validateInvoiceFiles(data)) {
      enqueueSnackbar(tGeneral("contingencyInvoicesWithoutFilesValidation"), { variant: 'warning' })
      return
    }

    setCircularLoading(true)


    var supplierTypesTemp = await MvmApi.getSupplierTypes(
      Number(data.shippingSupplier.code),
      Number(user.company.plantID),
      Number(user.company.companyID)).finally(() => setCircularLoading(false));

    setSupplierTypes(supplierTypesTemp);



    // O popup é exibido caso mais de uma condição descrita abaixo for verdadeira
    // JIT = true -> Botão Jit
    // JIT = false OU Misto = true -> Botão Kamban
    // E-kamban = true -> Botão E-Kamban
    // F = True -> Funilaria
    if ((supplierTypesTemp.jit && supplierTypesTemp.misto) || supplierTypesTemp.ekamban || supplierTypesTemp.funilaria || supplierTypesTemp.leapmotor)
      setOpenedPainel(true)
    else
      save(true, supplierTypesTemp.jit ? 'J' : 'K')
  }

  const submitMvm = (mvmType: string) => {
    save(true, mvmType)
  }

  const saveAccountingPendingUserResolution = async (mvmId: string) => {
    MvmApi.saveAccountingPendingUserResolution(mvmId);
  }

  const save = async (submit: boolean, mvmType: string) => {
    setOpenedPainel(false)

    let data = getValues();

    var validForm = await formValidation(data, submit || isEditFull)

    if (validForm === false) {
      return;
    }

    if (!validateInvoiceFiles(data)) {
      enqueueSnackbar(tGeneral("contingencyInvoicesWithoutFilesValidation"), { variant: 'warning' })
      return
    }

    setCircularLoading(true)

    var model = loadModelOutForm(data, submit, mvmType)

    if (!model.vehicleTypeDescription && model.vehicleType) {
      try {
        const vt = await VehicleTypeApi.getVehicleType(String(model.vehicleType));
        model.vehicleTypeDescription = vt?.description || '';
      } catch {
        model.vehicleTypeDescription = '';
      }
    }

    if (!model.vehicleTypeDescription) {
      enqueueSnackbar(tMvm("vehicleTypeDescriptionRequired") || "Tipo de veículo é obrigatório", { variant: 'warning' });
      setCircularLoading(false);
      return;
    }

    if (data.newVehicle) {
      VehicleApi.cadVehicle({
        cartPlateNumber: data?.cartPlateNumber,
        vehicleType: data?.vehicleType?.code,
        vehicleManufacturer: data?.vehicleBrandDescription,
        vehiclePlateNumber: data?.vehiclePlateNumber,
        companyId: +user.company.companyID,
      });
    }

    if (isInsert) {
      MvmApi.postMvm(model)
        .then((result: any) => {
          enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), { variant: 'success' });
          setMvmNumber(result.data?.mvmNumber);
          setMvmId(result.data?.id);

          if (submit) {
            setCartInfoAfterSubmit(result.data?.compositions)
            setSuccess(true);
          }
          else
            history.replace('/Mvm');
        })
        .catch(() => {
          setCircularLoading(false);
        })
        .finally(() => {
          setCircularLoading(false);
        });
    } else if (isEditDraft) {
      MvmApi.putMvm(model)
        .then((result: any) => {
          enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), { variant: 'success' })
          setMvmNumber(result.data?.mvmNumber);
          setMvmId(result.data?.id);

          if (submit) {
            setCartInfoAfterSubmit(result.data?.compositions)
            setSuccess(true);
          }
          else
            history.replace('/Mvm');

          // setMvmNumber(model?.mvmNumber); verificar se quando for rascunho é para
          // mostrar tbm a mensagem com o numero do MVM.

        })
        .finally(() => { setCircularLoading(false); });
    }
    else if (isEditFull) {
      MvmApi.putFullMvm(model)
        .then((result: any) => {
          enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), { variant: 'success' })
          setMvmNumber(result.data?.mvmNumber);
          setMvmId(result.data?.id);

          if (submit) {
            setCartInfoAfterSubmit(result.data?.compositions)
            setSuccess(true);
          }
          else
            history.replace('/Mvm');
        })
        .finally(() => { setCircularLoading(false); });
    }
  }

  const setCartInfoAfterSubmit = (compositions: any[]) => {
    if (compositions && compositions.length === 0)
      return

    setCartMvmNumber(compositions[0].cartMvm.mvmNumber);
    setCartMvmId(compositions[0].cartMvm.id);
  }

  const onAddInvoice = (newSupplier: any) => {

    var data = getValues()

    // DEVE SER MANTIDO O TO STRING POIS NÃO HÁ COMO GARANTIR O TIPO DO CAMPO DO data.suppliers ou do newSupplier
    if (data.suppliers.some((x: any) => x.code.toString() === newSupplier.code.toString()))
      return

    setValue('suppliers', [...data.suppliers, newSupplier])
  }

  const loadShedsRegistrations = async (shedList: [any]) => {
    if (mvm) {
      let sheRegs_: any[] = [];
      var listIds: number[] = [];
      shedList.forEach((i: any) => {
        listIds.push(+i.shedId);
      });

      await ShedApi.searchregistration({ shedIds: listIds, pageSize: 1000 }).then((response) => {
        //Construir para cada Shed deste componente, um objeto com shedId e lista de matriculas relacionadas a este shedId
        var shedRegs = shedList.map((x: any) => { return { ...x, registrations: [] } });

        //Para cada matricula da api, incluir ela na lista do shed relacionado:
        if (response && response.items) {
          for (let i = 0; i < shedRegs.length; i++) {
            shedRegs[i].registrations = response.items
              .filter((x: any) => +x.shedId === +shedRegs[i].shedId && +x.movementTypeId === +shedRegs[i].movementTypeId)
              .map((x: any) => ({ ...x, code: x.registrationUser, label: x.registrationUser + " - " + x.registrationUserName })); //ja deixar no formato certo pro <Select>
          }

          sheRegs_ = shedRegs.map((item: any, index: number) => {
            var registrations = [];
            var filterRegs = shedRegs.filter((x: any) => x.shedId === item.shedId).map((x: any) => x.registrations);
            if (filterRegs && filterRegs.length > 0)
              registrations = filterRegs[0];

            if (registrations.length === 1 && item.exitDate) {
              //exitOperator
              item.exitOperator = registrations[0];
              item.exitOperatorUserRegistration = registrations[0].registrationUser;
              item.exitOperatorUserName = registrations[0].registrationUserName;

              //exitConference
              item.exitConference = registrations[0];
              item.exitConferenceUserRegistration = registrations[0].registrationUser;
              item.exitConferenceUserName = registrations[0].registrationUserName;

            }
            return item;
          });
        }
      });

      setValue("mvmSheds", sheRegs_);

    }
  }

  const AuthorizeFCA = () => {
    setCircularLoading(true)
    MvmApi.authorizeFCA(mvm.id)
      .then((resp) => {
        setCircularLoading(false)
        setOpenedPainelAuthorizeFCA(false)
        history.replace(isViewPA ? '/PendingAccounting' : '/Mvm');
        //window.location.reload()
      })
  }

  if (success)
    return (
      <Container maxWidth={false} component="main">
        <div className={classes.rootContent}>
          <div className={classes.paper}>
            <Success opcoes={opcoes} MvmNumber={mvmNumber} MvmId={mvmId} />
            {cartMvmNumber && <Success opcoes={opcoesCart} MvmNumber={cartMvmNumber} MvmId={cartMvmId} />}
          </div>
        </div>
      </Container>
    )
  else
    return (
      <Container maxWidth={false} component="main">
        <Dialog
          open={openedPainelAuthorizeFCA}
          keepMounted
          onClose={() => setOpenedPainelAuthorizeFCA(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle
            id="draggable-dialog-title"
            onClose={() => setOpenedPainelAuthorizeFCA(false)}>
            {tGeneral("wishToAuthorizeFCA")}
          </DialogTitle>
          <DialogActions>
            <ButtonUI color="secondary" onClick={() => setOpenedPainelAuthorizeFCA(false)} >{tGeneral("cancel")}</ButtonUI>
            <ButtonUI color="primary" onClick={() => AuthorizeFCA()} >{tGeneral("confirm")}</ButtonUI>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openedPainel}
          keepMounted
          onClose={() => setOpenedPainel(false)}
          maxWidth={"lg"}
          aria-describedby="alert-dialog-slide-description" >
          <DialogTitle
            classes={{ root: classes.dialogTitle }}
            id="draggable-dialog-title"
            onClose={() => setOpenedPainel(false)}>
            {tMvm("mvmType")}
          </DialogTitle>
          <DialogContentText
            classes={{ root: classes.dialogContentText }}
            id="alert-dialog-description">
            {tMvm("setMvmTypeToContinue")}
          </DialogContentText>
          <DialogActions>

            {supplierTypes?.jit ?
              <AlertDialog
                dialogTitle={tMvm("confirm")}
                dialogContentText={tMvm("titleSetMvmTypeJIT")}
                cancelTextButton={tMvm("cancel")}
                confirmTextButton={tMvm("confirm")}
                confirmDialogFunction={() => { submitMvm('J') }}
                Button={<ButtonUI color="primary" startIcon={<SaveIcon />}>{"JIT"}</ButtonUI>} /> :
              <></>}

            {!supplierTypes?.jit || supplierTypes?.misto ?
              <AlertDialog
                dialogTitle={tMvm("confirm")}
                dialogContentText={tMvm("titleSetMvmTypeKamban")}
                cancelTextButton={tMvm("cancel")}
                confirmTextButton={tMvm("confirm")}
                confirmDialogFunction={() => { submitMvm('K') }}
                Button={<ButtonUI color="primary" startIcon={<SaveIcon />}>{tMvm('notJit')}</ButtonUI>} /> :
              <></>}

            {supplierTypes?.ekamban ?
              <AlertDialog
                dialogTitle={tMvm("confirm")}
                dialogContentText={tMvm("titleSetMvmTypeEkamban")}
                cancelTextButton={tMvm("cancel")}
                confirmTextButton={tMvm("confirm")}
                confirmDialogFunction={() => { submitMvm('E') }}
                Button={<ButtonUI color="primary" startIcon={<SaveIcon />}>{tMvm('ekamban')}</ButtonUI>} /> :
              <></>}

            {supplierTypes?.funilaria ?
              <AlertDialog
                dialogTitle={tMvm("confirm")}
                dialogContentText={tMvm("titleSetMvmTypeFunilaria")}
                cancelTextButton={tMvm("cancel")}
                confirmTextButton={tMvm("confirm")}
                confirmDialogFunction={() => { submitMvm('F') }}
                Button={<ButtonUI color="primary" startIcon={<SaveIcon />}>{tMvm('funilaria')}</ButtonUI>} /> :
              <></>}

            {supplierTypes?.leapmotor ?
              <AlertDialog
                dialogTitle={tMvm("confirm")}
                dialogContentText={tMvm("titleSetMvmTypeLeapmotor")}
                cancelTextButton={tMvm("cancel")}
                confirmTextButton={tMvm("confirm")}
                confirmDialogFunction={() => { submitMvm('L') }}
                Button={<ButtonUI color="primary" startIcon={<SaveIcon />}>{tMvm('leapmotor')}</ButtonUI>} /> :
              <></>}
          </DialogActions>
        </Dialog>
        <PageTitle title={title} />
        <div className={classes.rootContent}>
          <div className={classes.paper}>

            <form>

              <Grid container spacing={1}>
                <MvmSubmitSummary
                  control={control}
                  setValue={setValue}
                  getValues={getValues}
                  mvm={mvm}
                  isEditDraft={isEditDraft}
                  edit={!isView && !isViewDraft} />
              </Grid>

              {(isInsert || isEditDraft || isViewDraft) ?
                <Grid container spacing={1}>
                  <Grid item xs={12}>

                    <MvmInvoiceList
                      control={control}
                      name={"salesInvoices"}
                      allowAdd={!isViewDraft}
                      allowDelete={!isViewDraft}
                      Mvm={mvm}
                      allowUploadFile={!isView}
                      onAdd={onAddInvoice} />

                    {isCampoLargo() ?
                      <MvmInvoiceList
                        control={control}
                        name={"campolargoInvoices"}
                        title={tMvm("titleCampoLargoInvoices")}
                        allowAdd={!isViewDraft}
                        allowDelete={!isViewDraft}
                        Mvm={mvm}
                        allowUploadFile={!isView}
                        onAdd={onAddInvoice} />
                      : <></>
                    }

                    {isMopar() ?
                      <MvmInvoiceList
                        control={control}
                        name={"campolargoInvoices"}
                        title={tMvm("titleMoparContraTrabalhoInvoices")}
                        allowAdd={!isViewDraft}
                        allowDelete={!isViewDraft}
                        Mvm={mvm}
                        onAdd={onAddInvoice} />
                      : <></>
                    }

                    <MvmInvoiceList
                      control={control}
                      name={"otherInvoices"}
                      allowAdd={!isViewDraft}
                      allowDelete={!isViewDraft}
                      Mvm={mvm}
                      title={tMvm('otherInvoices')}
                      setTypeManually
                      allowUploadFile={!isView}
                      onAdd={onAddInvoice} />
                  </Grid>
                </Grid>
                :
                <>
                  <Grid container spacing={1}>
                    <MvmGeneralInfo
                      mvm={mvm}
                      control={control}
                      setValue={setValue}
                      edit={!isView} />
                  </Grid>

                  {/* Info da carreta de entrada para mvm composição */}
                  {mvmCompositionEntrance &&
                    <Grid container spacing={1}>
                      <MvmCompositionPartInfo
                        mvm={mvmCompositionEntrance}
                        control={control}
                        setValue={setValue}
                        full={true}
                        type={mvmCompositionEntrance.mvmType === 'C' ? tMvm('cart') : tMvm('cabin')}
                        movementType={tMvm('entrance')} />
                    </Grid>
                  }

                  {/* Info da carreta de saída para mvm composição */}
                  {mvmCompositionExit &&
                    <Grid container spacing={1}>
                      <MvmCompositionPartInfo
                        mvm={mvmCompositionExit}
                        control={control}
                        setValue={setValue}
                        full={true}
                        type={mvmCompositionExit.mvmType === 'C' ? tMvm('cart') : tMvm('cabin')}
                        movementType={tMvm('exit')} />
                    </Grid>
                  }

                  {!isCabinComposition &&
                    <>
                      <MvmInvoiceItemsList
                        control={control}
                        name={"invoiceItemsSales"}
                        allowDelete={!isView}
                        Mvm={mvm}
                        allowAdd={!isView}
                        allowUploadFile={!isView}
                        title="invoicesSales"
                        entranceDate={entranceDate} />

                      <MvmInvoiceItemsList
                        control={control}
                        name={"invoiceItemsRack"}
                        allowDelete={!isView}
                        Mvm={mvm}
                        allowAdd={!isView}
                        allowUploadFile={!isView}
                        title="invoicesRack"
                        isRack={true}
                        entranceDate={entranceDate} />

                      <MvmInvoiceItemsList
                        control={control}
                        name={"invoiceItemsGeneral"}
                        allowDelete={!isView}
                        Mvm={mvm}
                        allowAdd={!isView}
                        allowUploadFile={!isView}
                        setTypeManually
                        title="invoicesOthers"
                        entranceDate={entranceDate} />

                      <MvmShedList
                        editAll={!isView}
                        control={control}
                        name={"mvmSheds"}
                        title={tMvmShed('signatures')}
                        showColumns={["shedCode",
                          "checkInDate",
                          "entryDate",
                          "entryUser",
                          "exitDate",
                          "exitOperatorUser",
                          "exitConferenceUser",
                          "meansOfMovement",
                          "justification"]} />

                      <MvmRackLoadList
                        control={control}
                        title={tMvm('rackLoads')}
                        name={"rackLoads"}
                        allowAdd={false}
                        allowDelete={false}
                        allowInvoiceEdit={false}
                        allowRequestNumberEdit={false}
                        showColumns={
                          isJeep() ? ['typeCFOP', 'invoiceNumber', 'shedCode', 'transportOrder', 'company'] :
                            ['typeCFOP', 'invoiceNumber', 'shedCode', 'transportOrder', 'rackDispatchReturnMessage', 'company']
                        } />
                    </>
                  }
                </>
              }

              {!mvm ?
                <></>
                :
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <MvmLogList
                      loadingLog={loadingLog}
                      control={control}
                      name={"mvmLogs"}
                    />
                  </Grid>
                </Grid>
              }

              <Grid container spacing={1}>
                <Grid item xs={12} style={{ padding: "0px", textAlign: 'left', marginTop: "30px", marginLeft: "5px" }}>
                  <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                  <ButtonUI
                    variant="outlined"
                    color="secondary"
                    onClick={() => history.replace(isViewPA ? '/PendingAccounting' : '/Mvm')}
                    startIcon={<ArrowBack />}>
                    {tGeneral("back")}
                  </ButtonUI>
                  {isInsert ?
                    <ButtonUI onClick={() => save(false, mvmType)} color="primary" startIcon={<AddIcon />}>{tGeneral("add")}</ButtonUI>
                    : <></>}
                  {!isView && !isInsert ?
                    <ButtonUI onClick={() => save(false, mvmType)} color="primary" startIcon={<SaveIcon />}>{tGeneral("save")}</ButtonUI>
                    : <></>}
                  {(isInsert || isEditDraft) ?
                    <ButtonUI onClick={() => onSubmitMvm()} color="primary">{tGeneral("submitMvm")}</ButtonUI>
                    : <></>}
                  {+user.company.plantID === MOPAR_PLANT_ID && mvm?.submitDate != null && mvm?.releasedFCADate == null && isViewPA ?
                    <ButtonUI onClick={() => setOpenedPainelAuthorizeFCA(true)} color="primary">{tGeneral("authorizeFCA")}</ButtonUI>
                    : <></>}
                </Grid>
              </Grid>
            </form>
          </div>
        </div>
      </Container>
    )
}
export default Emitir;